module.exports = __webpack_public_path__ + "static/media/home4.de4d3783.jpg";